import {
  Course,
  MassAttendance,
  RegistrationByReceiver,
  RegistrationItem,
  RegistrationReq,
  RegistrationSummaryReq,
  StudentBasic,
  Teacher
} from '../models'
import {api} from './baseRtkqApi'

export const registrationApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRegistrations: build.query<RegistrationItem[], RegistrationReq>({
      query: (queryArg) => ({
        url: `/api/registration/current-year/check-registration-status`,
        method: 'GET',
        params: queryArg
      }),
    }),
    getAllCourses: build.query<Course[], void>({
      query: () => ({
        url: `/api/course/all/this-year`,
        method: 'GET',
      })
    }),
    getCourseTeachers: build.query<Teacher[], { courseId: number }>({
      query: (params) => ({
        url: `/api/course/${params.courseId}/enrollment?entities=teachers`,
        method: 'GET'
      }),
      transformResponse: (resp: { teachers: Teacher[] }) => resp.teachers
    }),
    getStudentById: build.query<StudentBasic, { studentId: string }>({
      query: (params) => ({
        url: `/api/student/basic/${params.studentId}`,
        method: 'GET'
      }),
    }),
    getMassAttendance: build.query<MassAttendance[], { studentId: string; fromDate: string; toDate: string }>({
      query: (params) => ({
        url: `/api/mass-attendance/student/${params.studentId}`,
        method: 'GET',
        params: { fromDate: params.fromDate, toDate: params.toDate }
      }),
    })
  }),
  overrideExisting: false,
})

export const registrationSummaryApi = api.injectEndpoints({
  endpoints: (build) => ({
    getRegistrationsSummary: build.query<RegistrationByReceiver, RegistrationSummaryReq>({
      query: (param) => ({
        url: `/api/registration/school-year/${param.schoolYearId || 5}/by-receiver`,
        method: 'GET',
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetAllCoursesQuery,
  useLazyGetCourseTeachersQuery,
  useLazyGetRegistrationsQuery,
  useGetStudentByIdQuery,
  useLazyGetMassAttendanceQuery,
} = registrationApi

export const {
  useGetRegistrationsSummaryQuery,
} = registrationSummaryApi
